import React from "react";
import { DocumentationLink } from "components/support";
import DocsHelper from "util/DocsHelper";
import useSearchVersionCheck from "hooks/useSearchVersionCheck";
import { ExternalLink } from "components/common";
const WarmTierSnapshotsText = () => {
  const { data, isLoading } = useSearchVersionCheck("datanode");
  const showDataNodeText = !isLoading && (data == null ? void 0 : data.satisfied);
  return /* @__PURE__ */ React.createElement("p", null, showDataNodeText ? "Data Node " : "At least one node in the cluster ", "must be configured with the", " ", /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://docs.opensearch.org/docs/latest/security/access-control/users-roles/" }, "search role"), " ", "in order to use the Warm Tier. See the Graylog Documentation on how to", " ", /* @__PURE__ */ React.createElement(
    DocumentationLink,
    {
      page: DocsHelper.PAGES.DATA_TIERING_WARM_TIER_SETUP,
      text: "Prepare Your Environment for a Warm Tier"
    }
  ), ".");
};
export default WarmTierSnapshotsText;
